<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="4">
                <el-input placeholder="机构名称" v-model="name"></el-input>
            </el-col>
            <el-col :span="4">
                <el-input placeholder="报警分类" v-model="type_name"></el-input>
            </el-col>
        </el-row>
        <el-row class="search-add" :gutter="10">
            <el-col :span="4">
                <el-date-picker
                    v-model="update_time"
                    type="date"
                    value-format="yyyyMMdd"
                    format="yyyy/MM/dd"
                    placeholder="修改时间">
                </el-date-picker>
            </el-col>
            <el-col :span="4">
                <el-date-picker
                    v-model="start_time"
                    type="date"
                    value-format="yyyyMMdd"
                    format="yyyy/MM/dd"
                    placeholder="起始时间">
                </el-date-picker>
            </el-col>
            <el-col :span="4">
                <el-date-picker
                    v-model="end_time"
                    type="date"
                    value-format="yyyyMMdd"
                    format="yyyy/MM/dd"
                    placeholder="结束时间">
                </el-date-picker>
            </el-col>
            <el-col :span="2">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="ins_name" label="机构名称">
            </el-table-column>
            <el-table-column prop="type_name" label="报警分类">
            </el-table-column>
            <el-table-column prop="duration_threshold" label="超阈值时间">
            </el-table-column>
            <el-table-column prop="update_time" label="修改时间">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="Edit(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="Delete(scope.$index)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        data() {
            return {
                name:'',
                type_name:'',
                start_time:'',
                update_time:'',
                end_time:'',
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    page: this.pagin.pageNum,
                    limit: this.pagin.pageSize,
                }
                if(this.name.trim() !='') {
                    params.name = this.name;
                }
                if(this.type_name.trim() !='') {
                    params.type_name = this.type_name;
                }
                if(this.update_time.trim() !='') {
                    params.update_time = this.update_time;
                }
                if(this.start_time.trim() !='') {
                    params.start_time = this.start_time;
                }
                if(this.end_time.trim() !='') {
                    params.end_time = this.end_time;
                }
                //传递页面绑定数据，进行查询
                this.$http.get('/manage/alert-time-threshold-change-log/list', {params:params}).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Delete(index) {
                //单删
                if(confirm('确认要删除吗？')) {
                    let ID = this.data[index].id;
                    this.$http.post('/manage/ability/del',{id:ID}).then(() => {
                        this.data.splice(index, 1);
                    })
                }
            },
            Edit(row) {
                this.$store.state.editInfo = row;
                this.$router.push('./edit/'+row.id);
            }
        },
        components: { Pagination }
    }
</script>

<style scoped>
el-date-picker,.el-date-editor{
    width: 100%;
}
</style>